module.exports = __webpack_public_path__ + "img/360-produktion-pos-1.f47a2125.jpg";